// @ts-nocheck
import { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Card,
  Table,
  Stack,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  Box,
  ListItemText,
  Modal,
  TextField,
} from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { BookingListHead } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import Loading from '../../components/Loading';
import React from 'react';
import { SelectDatepicker } from 'react-select-datepicker';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGetRevenueDataByParkingMutation, usePayToVendorMutation } from '../../store/api/revenueApi';
import { styled } from '@mui/material/styles';
import { getRevenueParking, getRevenueTotalRecordParking, setRevenueParking } from '../../store/state/revenueSlice';
import {
  capitalName,
  formatDateTime,
  getEndDate,
  getStartDate,
  GET_REVENUE_TABDATA,
  roundNumber,
  isWhatPercentOf,
} from '../../sections/@dashboard/parkingspaces/utility';
import { fDateTimeSuffix } from '../../utils/formatTime';
import { useCreateTransferMutation } from '../../store/api/StripeApi';
import toast from 'react-hot-toast';
import { useResolveDisputeMutation } from '../../store/api/bookingsApi';
import ClearIcon from '@mui/icons-material/Clear';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import { getAuthDetails } from '../../store/state/authSlice';
import { useExportToExcelMutation } from '../../store/api/excelRevenueApi';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import SearchNotFound from '../../components/SearchNotFound';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useFindByUserIdMutation, useSaveNotesDetailsMutation } from '../../store/api/notesApi';
import { getNote, getNoteTotalRecord, setNote } from '../../store/state/notesSlice';
import { getUserDetails } from '../../store/state/userSlice';
import { toUpper } from 'lodash';

const TABLE_HEAD_RESOLVE = [
  { id: 'CarName', label: 'Car Name', alignRight: false },
  { id: 'CarNumber', label: 'Car Number', alignRight: false },
  { id: 'BookingCode', label: 'Booking Code', alignRight: false },
  { id: 'CustomerName', label: 'Customer Name', alignRight: false },
  { id: ' BookingDate', label: ' Booking Date', alignRight: false },
  { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
  { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
  { id: 'resolveDate', label: 'Dispute Resolved Date', alignRight: false },
  { id: 'Amount', label: 'Amount', alignRight: false },
  // { id: 'Reward', label: 'Reward', alignRight: false },
  { id: 'BookingStatus', label: 'Booking Status', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
  { id: 'paymentStatus', label: 'Payment Status', alignRight: false },
  { id: 'BankStatus', label: 'Bank Status', alignRight: false },
  // { id: 'Add', label: 'Add Notes', alignRight: false },
  // { id: 'View', label: 'View Notes', alignRight: false },
];
const TABLE_HEAD_DISPUTE = [
  { id: 'CarName', label: 'Car Name', alignRight: false },
  { id: 'CarNumber', label: 'Car Number', alignRight: false },
  { id: 'BookingCode', label: 'Booking Code', alignRight: false },
  { id: 'CustomerName', label: 'Customer Name', alignRight: false },
  { id: ' BookingDate', label: ' Booking Date', alignRight: false },
  { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
  { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
  { id: 'disputeDate', label: 'Dispute Date', alignRight: false },
  { id: 'Amount', label: 'Amount', alignRight: false },
  // { id: 'Reward', label: 'Reward', alignRight: false },
  { id: 'BookingStatus', label: 'Booking Status', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
  // { id: 'Add', label: 'Add Notes', alignRight: false },
  // { id: 'View', label: 'View Notes', alignRight: false },
  { id: 'paymentStatus', label: 'Payment Status', alignRight: false },
  { id: 'BankStatus', label: 'Bank Status', alignRight: false },
];
const TABLE_HEADS = [
  { id: 'Name', label: 'Name', alignRight: false },
  { id: 'Description', label: 'Description', alignRight: false },
  { id: 'Add', label: 'Creation Date', alignRight: false },
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '20px',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
const NotesSchema = Yup.object().shape({
  description: Yup.string().required().typeError('Please enter description'),
});

let flag = ['Active_Transaction ', 'Disputed_Transaction'];

export default function ParkingWiseDataForAdmin() {
  const navigate = useNavigate();
  const editor = useRef(null);
  const location: any = useLocation();
  console.log(location, "location");
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [cancellations, setAllCancellations] = useState();
  const [orderBy, setOrderBy] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [value, setValue] = useState<Date | null>(new Date());
  const [variantName, setVariantName] = React.useState(getAllParking());
  const [getRevenueDataByParking, getAllResponse] = useGetRevenueDataByParkingMutation();
  const BookingData = useAppSelector(getRevenueParking);
  const token = JSON.parse(localStorage.getItem('login')).token || null;
  const userType = JSON.parse(localStorage.getItem('login')).userType || null;
  const User = JSON.parse(localStorage.getItem('login')) || null;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [editOpen, setEditOpen] = useState(false);
  const handleOpens = () => setEditOpen(true);
  const handleCloses = () => setEditOpen(false);
  const [showOpen, setShowOpen] = useState(false);
  const handleShowOpen = () => setShowOpen(true);
  const handleShowCloses = () => setShowOpen(false);
  const dispatch = useAppDispatch();
  const bookingTotalRecords = useAppSelector(getRevenueTotalRecordParking);
  const [resolveDispute, resolveDisputeResponse] = useResolveDisputeMutation();
  const [bookingSpaces, setParkingData] = useState({});
  const role = useAppSelector(getAuthDetails);
  const [saveOfferDetail, saveOfferDetailResponse] = useSaveNotesDetailsMutation();
  const [exportToExcel, exportToExcelResponse] = useExportToExcelMutation();
  const [noteData, noteDataResponse] = useFindByUserIdMutation();
  const [initialValues, setInitialValues] = useState({
    description: '',
  });
  const [bookingId, setBookingId] = useState({});
  const notesTotalRecord = useAppSelector(getNoteTotalRecord);
  const getnotesData = useAppSelector(getNote);
  const userData = useAppSelector(getUserDetails);
  const [notesData, setNotesData] = useState([]);
  const [pages, setPages] = useState(0);
  const [orders, setOrders] = useState('desc');
  const [selecteds, setSelecteds] = useState([]);
  const [orderBys, setOrderBys] = useState('id');
  const [rowsPerPages, setRowsPerPages] = useState(50);
  const [bookingIdS, setBookingIdS] = useState();
  const filteredNotes = noteDataResponse?.data?.data ? noteDataResponse?.data?.data : [];
  const [payToVendor, payToVendorResponse] = usePayToVendorMutation();
  const [openPayModal, setOpenPayModal] = useState(false);
  const handleOpenPayModal = () => setOpenPayModal(true);
  const handleClosePayModal = () => setOpenPayModal(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const handleOpenTransferModal = () => setOpenTransferModal(true);
  const handleCloseTransferModal = () => setOpenTransferModal(false);

  const GetAddNotes = (values: any) => {
    setBookingIdS(values);
    noteData({
      token: token,
      payload: {
        offset: rowsPerPages,
        page: pages,
        bookingId: values,
      },
    });
  };

  useEffect(() => {
    if (getnotesData) {
      setNotesData(getnotesData);
    }
  }, [getnotesData]);

  const handleAddNotes = (values: any, action: any) => {
    saveOfferDetail({
      token: token,
      payload: {
        description: values.description,
        userId: User.userId,
        bookingId: bookingId,
      },
    });
  };
  useEffect(() => {
    if (saveOfferDetailResponse.isSuccess) {
      toast.success('Successfully added note');
    }
    if (saveOfferDetailResponse.isError) {
      let errorData: any = saveOfferDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong. Please try again.' + msg || '');
    }
  }, [saveOfferDetailResponse.isSuccess, saveOfferDetailResponse.isError]);

  useEffect(() => {
    if (noteDataResponse.isSuccess) {
      dispatch(setNote(noteDataResponse.data));
    }
    if (noteDataResponse.isError) {
      let errorData: any = noteDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [noteDataResponse.isSuccess, noteDataResponse.isError]);

  const handleSelectAllClicks = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelecteds(newSelecteds);
      return;
    }
    setSelecteds([]);
  };

  const handleChangeNote = (event, newPages: any) => {
    setPages(newPages);
    noteData({
      token: token,
      payload: {
        offset: rowsPerPages,
        page: newPages,
        bookingId: bookingIdS,
      },
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBys === property && orders === 'asc';
    setOrders(isAsc ? 'desc' : 'asc');
    setOrderBys(property);
  };

  const handleChangeRowsPerPages = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setPages(0);
    noteData({
      token: token,
      payload: {
        offset: event.target.value,
        page: 0,
        bookingId: bookingIdS,
      },
    });
  };

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };
  const styleActiveModelEdit = {
    position: 'absolute' as 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };
  const styleActiveModelAdd = {
    position: 'absolute' as 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };
  const [valueTabs, setValueTabs] = useState(0);
  const [getFlag, setFlag] = useState(flag[0]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleChangeTabs = (event, newValue) => {
    console.log("handleChangeTabs")
    setValueTabs(newValue);
    setFlag(flag[newValue]);
    getRevenueDataByParking({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        parkingIdLists: getAllParkingId(),
        serviceProviderId: token.serviceProviderId,
        isDisputed: flag[newValue] == 'Disputed_Transaction' ? true : false,
      },
    });
  };

  const onDateChange = useCallback((date: Date) => {
    setValue(date);
  }, []);

  function getAllParkingId() {
    let parkingId: any = [];
    location.state.parkingSpaceRevenueDataList.forEach((item: any, index: number) => {
      parkingId.push(item.id);
    });
    return parkingId;
  }

  function getAllParking() {
    let parkingId: any = [];
    location.state.parkingSpaceRevenueDataList.forEach((item: any, index: number) => {
      parkingId.push(item);
    });
    return parkingId;
  }
  useEffect(() => {
    getRevenueDataByParking({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        parkingIdLists: getAllParkingId(),
        serviceProviderId: token.serviceProviderId,
        isDisputed: false,
      },
    });
  }, [getRevenueDataByParking]);

  const getRevenueDataAsync = async (newpage, parkingPerPage) => {
    await getRevenueDataByParking({
      token: token,
      payload: {
        page: newpage,
        offset: parkingPerPage,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        parkingIdLists: getAllParkingId(),
        serviceProviderId: token.serviceProviderId,
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  };

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setRevenueParking(getAllResponse.data));
      console.log(getAllResponse.data, "BookingData")

    }
  }, [getAllResponse.isSuccess]);

  useEffect(() => {
    if (BookingData) {
      setAllCancellations(BookingData);
    }
  }, [BookingData]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = cancellations.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getRevenueDataAsync(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getRevenueDataAsync(0, parseInt(event.target.value, 10));
  };

  const filteredUsers = cancellations?.data ? cancellations?.data : [];


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    let duplicateRemoved = [];
    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });
    setVariantName(duplicateRemoved);
  };

  function handlePayment() {
    let parkingIdLists: any = [];
    variantName.forEach((item: any, index: number) => {
      parkingIdLists.push(item.id);
    });
    payToVendor({
      token: token,
      payload: {
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: location.state.id,
        parkingIdLists: parkingIdLists,
      },
    });
    setOpenTransferModal(false);
  }
  const cancelTransfer = () => {
    setOpenTransferModal(false);
  };

  const handleClickButton = (id: any) => {
    console.log("Booking id", id);
    resolveDispute({
      token: token,
      payload: {
        bookingIds: [id],
        disputeResolutionDate: new Date(),
        isDisputed: true,
      },
    });
  };

  const handleSubmitExcel = (fileName: any) => {
    let parkingIdLists: any = [];
    variantName.forEach((item: any, index: number) => {
      parkingIdLists.push(item.id);
    });
    exportToExcel({
      token: token,
      fileName: userType,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: parkingIdLists,
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  };


  useEffect(() => {
    if (exportToExcelResponse.isSuccess) {
      console.log("exportToExcelResponse ", exportToExcelResponse);
      const url = window.URL.createObjectURL(new Blob([exportToExcelResponse.data]));
      const link: any = document.createElement("a");
      link.href = url;
      link.setAttribute(
        'download',
        `${formatDateTime(exportToExcelResponse?.originalArgs.toDate, 'MM/DD/yyyy') + '-RevenueData'}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [exportToExcelResponse.isSuccess]);

  function handleSubmits() {
    let parkingIdLists: any = [];
    variantName.forEach((item: any, index: number) => {
      parkingIdLists.push(item.id);
    });
    getRevenueDataByParking({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: parkingIdLists,
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  }

  const handleClick = (id: any) => {
    resolveDispute({
      token: token,
      payload: {
        bookingIds: [id],
        disputeResolutionDate: new Date(),
        isDisputed: false,
      },
    });
  };

  useEffect(() => {
    if (resolveDisputeResponse.isSuccess) {
      getRevenueDataByParking({
        token: token,
        payload: {
          offset: rowsPerPage,
          page: page,
          fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
          toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
          parkingIdLists: getAllParkingId(),
          isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
        },
      });
      if (getFlag == 'Disputed_Transaction') {
        toast.success('Transaction resolved successfully.');
      } else {
        toast.success('Transaction marked as dispute.');
      }
    } else if (resolveDisputeResponse.isError) {
      let errorData: any = resolveDisputeResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [resolveDisputeResponse.isSuccess, resolveDisputeResponse.isError]);

  const cancelPay = () => {
    setOpenPayModal(false);
  };

  const handlePay = () => {
    console.log("call function ")
    payToVendor({
      token: token,
      payload: {
        bookingIds: [bookingId],
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: location.state.id,
      },
    });
    setOpenPayModal(false);
  };

  useEffect(() => {
    if (payToVendorResponse.isSuccess) {
      toast.success('Payment successfull.');
      getRevenueDataByParking({
        token: token,
        payload: {
          offset: rowsPerPage,
          page: page,
          fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
          toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
          serviceProviderId: token.serviceProviderId,
          parkingIdLists: getAllParkingId(),
          isDisputed: false,
        },
      });
    } else if (payToVendorResponse.isError) {
      let errorData: any = payToVendorResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong. ' + msg || '');
    }
  }, [payToVendorResponse.isSuccess, payToVendorResponse.isError]);

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Revenue">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Vendor Revenue
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              navigate('/dashboard/admin-revenue', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>

        <Card>
          <ResponsiveBox style={{ display: 'flex' }}>
            <Box style={{ marginLeft: '20px', marginTop: '33px' }}>
              <div>
                <FormControl>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={variantName}
                    onChange={handleChange}
                    renderValue={(selected) =>
                      selected.length > 0 ? selected.map((x) => x.name || x.vehicleDetailObj?.model).join(', ') : "Select Variants"
                    }
                    style={{ width: '250px', marginTop: '8px' }}
                  >
                    {location.state.parkingSpaceRevenueDataList &&
                      location.state.parkingSpaceRevenueDataList.map((variant) => (
                        <MenuItem key={variant.id} value={variant}>
                          <Checkbox checked={variantName.findIndex((item) => item.id === variant.id) >= 0} />
                          <ListItemText primary={variant.vehicleDetailObj?.model} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </Box>
            <Box>
              <SelectDatepicker selectedDate={value} onDateChange={onDateChange} order="month/year" hideLabels="true" />
            </Box>

            <Button
              className="ButtonWith"
              style={{
                width: '50px',
                borderColor: 'red',
                padding: '10px',
                marginLeft: '10px',
                alignItems: 'center',
                height: '52px',
                marginTop: '40px',
                fontWeight: 'bold',
                backgroundColor: '#E23744'
              }}
              onClick={() => {
                handleSubmits();
              }}
              variant="contained"
            >
              Submit
            </Button>

            <Button
              className="ButtonWith"
              style={{
                width: '50px',
                borderColor: 'red',
                padding: '10px',
                marginLeft: '10px',
                alignItems: 'center',
                height: '52px',
                marginTop: '40px',
                fontWeight: 'bold',
                backgroundColor: '#E23744'
              }}
              onClick={() => {
                handleSubmitExcel(filteredUsers[0].vendorAlias);
              }}
              variant="contained"
            >
              Excel Export
            </Button>

            {/* <button
              className="ButtonWith"
              style={{
                width: '60px',
                padding: '10px',
                marginLeft: '10px',
                alignItems: 'center',
                backgroundColor: 'red',
                marginTop: '40px',
                borderRadius: '8px',
                color: 'white',
                borderColor: 'red',
                height: '52px',
              }}
              onClick={() => {
                handleSubmit();
              }}
              variant="contained"
            >
              PDF
            </button>  */}
          </ResponsiveBox>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            mb={5}
            mt={5}
            style={{ width: '100%' }}
          >
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="nav tabs example"
              style={{ width: '100%' }}
              className="tabResponsive"
            >
              <LinkTab label="Active Transaction" style={{ width: '100%' }} />
              <LinkTab
                label="Disputed Transaction"
                style={{ width: '100%', marginLeft: '300px' }}
                className="linkResponsive"
              />
            </Tabs>
          </Stack>

          <Stack mb={3} style={{ marginLeft: '10px', marginTop: '20px' }}>
            <Typography variant="h4" gutterBottom>
              Summary of Listing Activity
            </Typography>
          </Stack>

          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <tr>
              <th
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Transactions
              </th>
              <th
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Amount
              </th>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Number of Transactions
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                {cancellations?.totalRecords}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Number of Cancelled Bookings
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                {cancellations?.totalCancelledBooking}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Gross Amount
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalGrossAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Cancelled Transactions Amount
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalCancellationAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Amount before Tax
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalBookingAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Tax Collected
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalTaxAmount)}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Amount after Tax collected
              </td>
              <td
                style={{
                  textAlign: 'left',
                  alignItems: 'center',
                  padding: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                  gap: '20px',
                  display: 'flex',
                }}
              >
                ₹{roundNumber(cancellations?.totalVendorCommission)}
                {cancellations?.totalVendorCommission === cancellations?.totalPaidAmount ? (
                  <p style={{ color: 'green', fontWeight: 'bold' }}>
                    ₹{roundNumber(cancellations?.totalPaidAmount)} PAID On{' '}
                    {formatDateTime(cancellations?.vendorPaymentDetails.transactionDate, 'MM/DD/yyyy, hh:mm A')}
                  </p>
                ) : (
                  null
                  // <Button
                  //   className="ButtonWith"
                  //   style={{
                  //     width: '50%',
                  //     borderColor: '#E23744',
                  //     padding: '8px',
                  //     alignItems: 'center',
                  //     height: '20%',
                  //   }}
                  //   onClick={() => {
                  //     handleOpenTransferModal();
                  //   }}
                  //   disabled={
                  //     cancellations?.totalVendorCommission == 0
                  //     //  || !cancellations?.isStripeOnboarded ? true : false
                  //   }
                  //   variant="contained"
                  // >
                  //   Transfer (₹{roundNumber(cancellations?.totalVendorCommission)})
                  // </Button>
                )}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Car Rental Revenue (Including Convenience)
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalCommissionAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Convenience Fee
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalConvenience)}
              </td>
            </tr>
            {/**<tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total County Tax
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalCountyTax)}
              </td>
            </tr> */}
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total CGST
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalSalesTax)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total SGST
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalStateTax)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Fixed Fee
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalFixedFee)}
              </td>
            </tr>
          </table>



          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={getFlag == 'Disputed_Transaction' ? TABLE_HEAD_DISPUTE : TABLE_HEAD_RESOLVE}
                  rowCount={cancellations?.length}
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        name,
                        bookingDate,
                        checkInDate,
                        checkOutDate,
                        rewardUsedAmount,
                        isVendorPaid,
                        bookingCode,
                        bookingStatus,
                        customerName,
                        actualCheckOutDate,
                        actualCheckInDate,
                        parkingSpaceLocationName,
                        totalAmount,
                        bookingId,
                        disputeResolutionDate,
                        vehicleDetailObj,
                        paymentMethodName,
                        bankStatus,
                        paymentStatus
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">{vehicleDetailObj.model}</TableCell>
                          <TableCell align="left">{vehicleDetailObj.registrationNumber}</TableCell>
                          <TableCell
                            align="left"
                            style={{
                              color: 'blue',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setParkingData(row);
                              handleOpen();
                            }}
                          >
                            {bookingCode}
                          </TableCell>
                          <TableCell align="left">{customerName}</TableCell>
                          <TableCell align="left">{fDateTimeSuffix(bookingDate)}</TableCell>
                          <TableCell align="left">{fDateTimeSuffix(checkInDate)}</TableCell>
                          <TableCell align="left"> {fDateTimeSuffix(checkOutDate)}</TableCell>
                          <TableCell align="left">{disputeResolutionDate ? (fDateTimeSuffix(disputeResolutionDate)) : "N/A"}</TableCell>
                          <TableCell align="left">₹{roundNumber(totalAmount)}</TableCell>
                          {/* <TableCell align="left">{roundNumber(rewardUsedAmount)}</TableCell> */}
                          <TableCell align="left" style={{ fontWeight: 'bold' }}>
                            {toUpper(
                              actualCheckInDate != null && actualCheckOutDate == null && bookingStatus == 'booked'
                                ? 'CHECKIN'
                                : capitalName(bookingStatus)
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {isVendorPaid === true ? (
                              <p style={{ color: 'green', fontWeight: 'bold', textAlign: 'center' }}>PAID</p>
                            ) : (
                              <p style={{ color: 'red', fontWeight: 'bold' }}>
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    handleOpenPayModal();
                                    setBookingId(id);
                                  }}
                                  disabled={(bookingStatus !== 'Completed') || (paymentMethodName == "Cash")}
                                >
                                  Pay
                                </Button>
                              </p>
                            )}
                          </TableCell>

                          {getFlag == 'Disputed_Transaction' ? (
                            <TableCell align="left">
                              <Button style={{ color: 'white', backgroundColor: '#E23744' }} variant="contained" onClick={() => handleClick(id)}>
                                Resolve
                              </Button>
                            </TableCell>
                          ) : (
                            <TableCell align="left">
                              <Button variant="contained" style={{ color: 'white', backgroundColor: '#E23744' }} onClick={() => handleClickButton(id)}>
                                Dispute
                              </Button>
                            </TableCell>
                          )}
                          <TableCell align="left">{paymentStatus}</TableCell>
                          <TableCell align="left">{bankStatus?bankStatus:"-"}</TableCell>
                          {/* 
                          <TableCell align="left">
                            <EditIcon
                              onClick={() => {
                                console.log(bookingId, "bookingId");
                                handleOpens();
                                setBookingId(id);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <RemoveRedEyeIcon
                              onClick={() => {
                                console.log(bookingId, "bookingId");
                                handleShowOpen();
                                GetAddNotes(id);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              {filteredUsers.length == 0 ? (
                <Typography gutterBottom align="center" variant="subtitle1" style={{ marginTop: 25, marginBottom: 25 }}>
                  No record found!!!{' '}
                </Typography>
              ) : (
                ''
              )}
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Modal
        open={openPayModal}
        onClose={handleClosePayModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
            Are you sure?
          </Typography>
          <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
            <Button variant="contained" onClick={cancelPay} sx={{ margin: '10px' }} color="error">
              No
            </Button>
            <Button variant="contained" onClick={handlePay} sx={{ margin: '10px' }}>
              Yes
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={openTransferModal}
        onClose={handleCloseTransferModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
            Are you sure?
          </Typography>
          <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
            <Button variant="contained" onClick={cancelTransfer} sx={{ margin: '10px' }} color="error">
              No
            </Button>
            <Button variant="contained" onClick={handlePayment} sx={{ margin: '10px' }}>
              Yes
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%' }}
      >
        <Box sx={styleActiveModel} style={{ overflowY: 'auto', height: '85%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Booking Details
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleClose();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Box border={1} borderRadius={2} borderColor={'white'} style={{ backgroundColor: 'white' }}>
            <Box marginLeft={1} padding={3}>
              <Box>
                <Box>
                  <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Customer Name :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.customerName && bookingSpaces?.customerName
                        ? capitalName(bookingSpaces?.customerName)
                        : null}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Vehicle Name :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.vehicleDetailObj?.model && bookingSpaces?.vehicleDetailObj?.model
                        ? capitalName(bookingSpaces?.vehicleDetailObj?.model)
                        : null}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Code :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.bookingCode}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Transaction Id :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.transactionRefId}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Pickup Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.checkInDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Dropoff Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.checkOutDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Booking Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.bookingDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Status :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces.actualCheckInDate !== null &&
                        bookingSpaces.actualCheckOutDate == null &&
                        bookingSpaces.bookingStatus == 'booked'
                        ? 'Checkin'
                        : bookingSpaces.bookingStatus}
                    </Typography>
                  </Box>
                  {bookingSpaces.cancellationReasonName == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                        Cancellation Reason:
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                        {bookingSpaces.cancellationReasonName}
                      </Typography>
                    </Box>
                  )}

                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Amount :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.bookingAmount}
                    </Typography>
                  </Box>

                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Total Tax &nbsp;&nbsp;&nbsp;&nbsp;:
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.taxAmount}
                    </Typography>
                  </Box>
                  {role && role.roleIdName == 'Super Admin' ? (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                        Convenience Fee :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                        ₹{bookingSpaces.convenienceFee}
                      </Typography>
                    </Box>
                  ) : null}
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Used Reward :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.rewardUsed == null || 0 ? 0 : bookingSpaces?.rewardUsed}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Total Booking Amount :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces.totalAmount}
                    </Typography>
                  </Box>
                  {/**bookingSpaces.countyTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        County Tax Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                      ₹{bookingSpaces.countyTax}
                      </Typography>
                    </Box>
                  )*/}
                  {bookingSpaces.salesTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        CGST Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.salesTax}
                      </Typography>
                    </Box>
                  )}
                  {bookingSpaces.stateTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        SGST Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.stateTax}
                      </Typography>
                    </Box>
                  )}
                  {bookingSpaces.fixedFee == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        Fixed Fee:
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.fixedFee}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={editOpen}
        onClose={handleCloses}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%' }}
      >
        <Box sx={styleActiveModelEdit} style={{ overflowY: 'auto', height: '70%', width: '50%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Add Notes
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleCloses();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleAddNotes}
            validationSchema={NotesSchema}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors, resetForm }) => (
              <Box>
                <Box style={{ width: '100%' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Description
                  </Typography>
                  <TextField
                    type="description"
                    id="description"
                    name="description"
                    label="description"
                    multiline
                    rows={6}
                    style={{ width: '100%' }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.description && errors.description)}
                    helperText={touched.description && errors.description}
                  />
                </Box>
                <Stack direction="row" justifyContent={'end'} marginTop={'20px'} alignItems={'center'}>
                  <Button
                    onClick={() => {
                      handleSubmit();
                      handleCloses();
                    }}
                    variant="contained"
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    sx={{ padding: '8px', width: '100px' }}
                  >
                    ADD
                  </Button>
                </Stack>
              </Box>
            )}
          </Formik>
        </Box>
      </Modal>
      <Modal
        open={showOpen}
        onClose={handleShowCloses}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%', innerHeight: '50%' }}
      >
        <Box sx={styleActiveModelAdd} style={{ overflowY: 'auto', width: '60%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Notes Details
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleShowCloses();
                setPages(0);
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={orders}
                  orderBy={orderBys}
                  headLabel={TABLE_HEADS}
                  rowCount={notesData.length}
                  numSelected={selecteds.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClicks}
                />
                <TableBody>
                  {filteredNotes.length > 0 &&
                    filteredNotes.map((row) => {
                      const { id, createdByName, createdDate, description } = row;
                      const isItemSelected = selecteds.indexOf(createdByName) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {createdByName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {description}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {formatDateTime(createdDate, 'MM/DD/yyyy, hh:mm A')}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {filteredNotes.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={notesTotalRecord || 0}
            rowsPerPage={rowsPerPages}
            page={pages}
            onPageChange={handleChangeNote}
            onRowsPerPageChange={handleChangeRowsPerPages}
          />
        </Box>
      </Modal>

      {getAllResponse.isLoading ||
        payToVendorResponse.isLoading ||
        noteDataResponse.isLoading ||
        resolveDisputeResponse.isLoading ? (
        <Loading />
      ) : null}
    </Page>
  );
}
